import React, { createContext, useState, useContext, useReducer } from 'react';
import { alertReducer, GlobalAlertInitState, GlobalAlertEvent, GlobalAlertProps, parseMessageProps} from "components/Common/GlobalAlert";

interface PartnerDetails {
  partner: string;
}

const partnerDetailsInitState = {
  partner: ''
};

interface AppContext {
  hasLogin: boolean;
  hideLogin: () => void;
  showLogin: () => void;
  partnerDetails: { partner: string };
  updatePartnerDetails: (details) => void;
  updateAlert: (message: string | parseMessageProps) => void;
  closeAlert: () => void;
  alertState: GlobalAlertProps;
}

interface AppDataOptions {
  children: React.ReactNode;
  hasLogin?: boolean;
  hideLogin?: () => void;
  showLogin?: () => void;
  partnerDetails?: { partner: string };
  updatePartnerDetails?: (details) => void;
  updateAlert?: (message: string | parseMessageProps) => void;
  closeAlert?: () => void;
  alertState?: GlobalAlertProps;
}

const AppContext = createContext<AppContext>({
  hasLogin: true,
  hideLogin: () => {},
  showLogin: () => {},
  partnerDetails: { partner: '' },
  updatePartnerDetails: () => {},
  updateAlert: () => {},
  alertState: GlobalAlertInitState,
  closeAlert: () => {},
});

export const AppDataProvider = ({ children }: AppDataOptions) => {
  const [hasLogin, setHasLogin] = useState(false);
  const hideLogin = () => {
    setHasLogin(false);
  };
  const showLogin = () => {
    setHasLogin(true);
  };

  const [partnerDetails, setPartnerDetails] = useState<PartnerDetails>(
    partnerDetailsInitState
  );
  const updatePartnerDetails = details => {
    setPartnerDetails(details);
  };
  
  const [alertState, dispatchAlert] = useReducer(alertReducer, GlobalAlertInitState);

  const updateAlert = (message) => {
    dispatchAlert({type: GlobalAlertEvent.ALERT, payload: { message: message }})
  };

  const closeAlert = () => {
    dispatchAlert({type: GlobalAlertEvent.CLOSE})
  };

  return (
    <AppContext.Provider
      value={{
        hideLogin,
        hasLogin,
        showLogin,
        partnerDetails,
        updatePartnerDetails,
        updateAlert,
        closeAlert,
        alertState
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppData = () => useContext(AppContext);
